import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'
import pluralize from '../../utils/pluralize'

export default function getConstants(p = {}) {

    const name = 'apiKey'
    const n = name
    const N = capitalize(n)
    const ns = pluralize(name)
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'API kulcsok törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            [n + 'PlaintextDialogCopy']: 'Másolás vágólapra',
            [n + 'PlaintextDialogContinue']: 'Tovább',
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'API kulcsok',
            ['my' + Ns + 'Menu']: 'API kulcsaim',
            ['new' + N + 'Menu']: 'Új API kulcs',
            [ns + 'Menu']: 'API kulcsok',
            ['deleted' + Ns + 'Menu']: 'Törölt API kulcsok',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt API kulcsok',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az új API kulcs létrehozva',
            ['save' + N + 'SuccessMessage']: 'Az API kulcs mentésre került',
            ['delete' + N + 'Success']: 'Az API kulcs törölve lett',
            ['delete' + Ns + 'Success']: 'Az API kulcsok törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli az API kulcsot?',
            ['delete' + Ns + 'Question']: 'Biztosan törli az API kulcsokat?',
            ['ban' + N + 'Success']: 'Az API kulcs véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztosan véglegesen törölni akarod az API kulcsot?',
            ['approve' + N + 'Success']: 'Az API kulcs jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod az API kulcsot?',
            ['thereAreNo' + Ns]: 'Nincsenek API kulcsok',
            [n + "PlaintextLabel"]: 'Api kulcs',
            [n + 'PlaintextCopied']: 'A kulcs vágólapra másolva.',
            [n + 'PlaintextCopyError']: 'A vágólapra másolás nem sikerült.'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'API kulcs',
            [ns + 'Title']: 'API kulcsok',
            ['new' + N + 'Title']: 'Új API kulcs',
            ['edit' + N + 'Title']: 'API kulcs szerkesztése',
            ['user' + Ns + 'Title']: 'API kulcsok',
            ['userDeleted' + Ns + 'Title']: 'Törölt API kulcsok',
            ['my' + Ns + 'Title']: 'API kulcsaim',
            ['myDeleted' + Ns + 'Title']: 'Törölt API kulcsaim',

            ['dialogDelete' + N + 'Title']: 'API kulcs törlése',
            ['dialogBan' + N + 'Title']: 'API kulcs törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'API kulcs jóváhagyása',

            ['dialogDelete' + Ns + 'Title']: 'API kulcsok törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            [n + 'PlaintextDialogTitle']: 'API kulcs létrehozva',


            ['banned' + Ns + 'Title']: 'Véglegesen törölt API kulcsok',
            ['deleted' + Ns + 'Title']: 'Törölt API kulcsok',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok'
        }
    }
}
